import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Wait4Me from '../../../components/Wait4Me';

const DownloadDropdown = ({
  onDownloadCurrentPage,
  onDownloadAll,
  isDownloading,
  isDisabled,
  currentPageCount = 0,
  totalCount = 0
}) => {
  const menu = (
    <Menu>
      <Menu.Item
        key="current-page"
        onClick={onDownloadCurrentPage}
        disabled={isDisabled}>
        Download Current Page ({currentPageCount} records)
      </Menu.Item>
      <Menu.Item key="all" onClick={onDownloadAll} disabled={isDisabled}>
        Download All Matching ({totalCount} records)
      </Menu.Item>
    </Menu>
  );

  if (isDownloading) {
    return <Wait4Me />;
  }

  return (
    <Dropdown
      overlay={menu}
      disabled={isDisabled}
      trigger={['click']}
      placement="bottomRight">
      <Button icon={<DownloadOutlined />} disabled={isDisabled}>
        Download
      </Button>
    </Dropdown>
  );
};

DownloadDropdown.propTypes = {
  onDownloadCurrentPage: PropTypes.func.isRequired,
  onDownloadAll: PropTypes.func.isRequired,
  isDownloading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  currentPageCount: PropTypes.number,
  totalCount: PropTypes.number
};

export default DownloadDropdown;
